import gql from 'graphql-tag'

export default gql`
  mutation markNotificationRead($input: MarkNotificationReadInput!) {
    markNotificationRead(input: $input) {
      notification {
        rid
        read
        type
      }
    }
  }
`
